"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VSearchSelectField = void 0;
var react_1 = __importStar(require("react"));
var core_1 = require("@blueprintjs/core");
var mobx_react_1 = require("mobx-react");
var FormFieldContainer_1 = require("../FormFieldContainer");
var SearchSelect_1 = require("./SearchSelect");
var style_1 = require("../style");
var Validators_1 = require("../../Validators");
exports.VSearchSelectField = (0, mobx_react_1.observer)(function (props) {
    var label = props.label, labelInfo = props.labelInfo, fieldState = props.fieldState, disabled = props.disabled, inline = props.inline, options = props.options, className = props.className, layer = props.layer, fill = props.fill, noLabel = props.noLabel, required = props.required, validators = props.validators, fixedInputWidthPx = props.fixedInputWidthPx, id = props.id, margin = props.margin, tipLabel = props.tipLabel, tooltip = props.tooltip, displayRequired = props.displayRequired, value = props.value, multi = props.multi, allowNewItem = props.allowNewItem, onAddNewItem = props.onAddNewItem, popoverWidth = props.popoverWidth, sort = props.sort, allowEmpty = props.allowEmpty, popoverMinimal = props.popoverMinimal, tipBgColor = props.tipBgColor, displayAsTree = props.displayAsTree, treeChildIndentWidth = props.treeChildIndentWidth, getValueOnSelectMenuItem = props.getValueOnSelectMenuItem, loading = props.loading, placeholder = props.placeholder;
    (0, react_1.useEffect)(function () {
        if (fieldState) {
            if (required) {
                if (validators && validators.length > 0) {
                    fieldState.validators.apply(fieldState, __spreadArray([Validators_1.Validators.required], validators, false));
                }
                else {
                    fieldState.validators(Validators_1.Validators.required);
                }
            }
            else if (validators && validators.length > 0 && fieldState.validators) {
                fieldState.validators.apply(fieldState, validators);
            }
        }
    }, [validators]);
    var changeValueOrField = function (value) {
        if (props.fieldState) {
            props.fieldState.onChange(value);
        }
        if (props.onChange) {
            props.onChange(value);
        }
    };
    return (react_1.default.createElement(style_1.StyledPopOverWrapper, { disabled: disabled, inline: inline, intent: fieldState && fieldState.hasError ? core_1.Intent.DANGER : core_1.Intent.NONE, labelFor: id, labelInfo: labelInfo, layer: layer, fill: fixedInputWidthPx ? false : fill, noLabel: noLabel, fixedInputWidthPx: fixedInputWidthPx, margin: margin },
        react_1.default.createElement(FormFieldContainer_1.FormFieldContainer, { required: required || displayRequired, noLabel: noLabel, label: label, fieldState: fieldState, tooltip: tooltip, className: className },
            tipLabel && (react_1.default.createElement("span", { className: 'tipLabel', style: { backgroundColor: tipBgColor ? tipBgColor : '#fff' } }, tipLabel)),
            react_1.default.createElement(SearchSelect_1.SearchSelect, { disabled: disabled, sort: sort, value: props.fieldState ? props.fieldState.value : value, options: options != null && Array.isArray(options) ? options : [], multi: multi, onChange: changeValueOrField, allowNewItem: allowNewItem, onAddNewItem: onAddNewItem, popoverWidth: popoverWidth, fixedInputWidthPx: fixedInputWidthPx, allowEmpty: allowEmpty, popoverMinimal: popoverMinimal, displayAsTree: displayAsTree, treeChildIndentWidth: treeChildIndentWidth, getValueOnSelectMenuItem: getValueOnSelectMenuItem, isLoading: loading, placeholder: placeholder, displayValueTooltip: props.displayValueTooltip }))));
});
